import React from 'react';
//import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
//import Link from '@/src/components/Link/Link';
import Input from '@/src/components/Antd/NumberInput/NumberInput';
import css from './css.less';
// import CustomCollapse from '@/src/components/Antd/SingleCollapse/Collapse';
// import EditableTable from '@/src/components/EditableTable/EditableTable';
// import TotalAndLeft from './TotalAndLeft';
import Checkbox from '@/src/components/Antd/Checkbox/Checkbox';
import { getError } from 'src/tools/helper';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Stock = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data = {}, setData, disabled } = props;
  //const isGift = hideCheckbox;
  const { stockAvailableUnlimited, stockAvailable, stockSold } = data;

  const quotaEnabledChange = (e) => {
    if (setData)
      setData({
        stockAvailableUnlimited: e,
        stockAvailable: '',
      });
  };
  const stockAvailableChange = (e) => {
    if (setData) {
      setData({
        stockAvailable: e, //>= 1 ? Math.abs(Number.parseInt(e)) : '',
      });
    }
  };

  return (
    <React.Fragment>
      <Row
        // hasBottomBorder={!stockAvailableUnlimited}
        borderBottomClassName={stockAvailableUnlimited ? css.borderBottom : ''}
        elements={[
          {
            child: (
              <ItemWrapper
                title={
                  <Checkbox
                    onChange={quotaEnabledChange}
                    disabled={disabled}
                    checked={stockAvailableUnlimited}>
                    {getI18n('allProducts.addproductset.unlimitedquantity')}
                  </Checkbox>
                }
                bottomTitle={getI18n(
                  'allProducts.addproductset.uncheckedinputquantitylimitation',
                )}></ItemWrapper>
            ),
          },
          {
            child: stockAvailableUnlimited ? (
              <div className={css.soldTotalContainer}>
                <ItemWrapper
                  title={getI18n('allProducts.addproductset.sold')}
                  containerClassName={css.innerContainer}>
                  <div className={css.count}>{stockSold || 0}</div>
                </ItemWrapper>
                <ItemWrapper
                  title={getI18n('allProducts.addproductset.total')}
                  containerClassName={css.innerContainer}>
                  <div className={css.count}>—</div>
                </ItemWrapper>
              </div>
            ) : (
              <React.Fragment />
            ),
          },
        ]}
      />

      {!stockAvailableUnlimited ? (
        <Row
          //   hasBottomBorder={!stockAvailableUnlimited}
          borderBottomClassName={css.borderBottom}
          elements={[
            {
              child: !stockAvailableUnlimited ? (
                <ItemWrapper
                  title={`${getI18n(
                    'allProducts.addproductset.availableQuantity',
                  )}*`}>
                  <Input
                    min={0}
                    precision={0}
                    disabled={disabled}
                    // max={stockQuantity || 0}
                    size='large'
                    value={stockAvailable}
                    onChange={stockAvailableChange}
                    error={getError('stockAvailable', data)}
                  />
                </ItemWrapper>
              ) : null,
            },
            {
              child: (
                <div className={css.soldTotalContainer}>
                  <ItemWrapper
                    title={getI18n('allProducts.addproductset.sold')}
                    containerClassName={css.innerContainer}>
                    <div className={css.count}>{stockSold || 0}</div>
                  </ItemWrapper>
                  <ItemWrapper
                    title={getI18n('allProducts.addproductset.total')}
                    containerClassName={css.innerContainer}>
                    <div className={css.count}>
                      {(stockSold || 0) + (stockAvailable || 0)}
                    </div>
                  </ItemWrapper>
                </div>
              ),
            },
          ]}
        />
      ) : null}
    </React.Fragment>
  );
};
export default Stock;
